/* eslint-disable import/no-anonymous-default-export */

import heFooter from './he';
import enFooter from './en';

export default {
    he: heFooter,
    en: enFooter,
};